/**
 * The words of the paper chosen at print time (docs/design/print-paper-toolbar.md): the group the
 * list's export dialog gains for PDF and Word, and the report's paper dialog, which says the same.
 * Kept beside the catalogue and spread into it.
 */
export const PAPER_EN = {
    'list.export.paper': 'Paper',
    'list.export.paper.title': 'Paper for this file',
    'list.export.paper.a4': 'A4',
    'list.export.paper.a3': 'A3',
    'list.export.paper.a5': 'A5',
    'list.export.paper.letter': 'Letter',
    'list.export.paper.screen': 'The screen’s size',
    'list.export.orientation': 'Orientation',
    'list.export.orientation.portrait': 'Portrait',
    'list.export.orientation.landscape': 'Landscape',
    'list.export.orientation.auto': 'Automatic',
    'list.export.paper.declared': 'As the screen sets it: {paper}, {orientation}',
    'list.export.paper.changed': 'For this print only — what the screen sets does not change',
};
export const PAPER_AR = {
    'list.export.paper': 'الورق',
    'list.export.paper.title': 'ورق هذا الملف',
    'list.export.paper.a4': 'A4',
    'list.export.paper.a3': 'A3',
    'list.export.paper.a5': 'A5',
    'list.export.paper.letter': 'Letter',
    'list.export.paper.screen': 'مقاس الشاشة',
    'list.export.orientation': 'الاتجاه',
    'list.export.orientation.portrait': 'طولي',
    'list.export.orientation.landscape': 'عرضي',
    'list.export.orientation.auto': 'تلقائي',
    'list.export.paper.declared': 'كما تحدّده الشاشة: {paper}، {orientation}',
    'list.export.paper.changed': 'لهذه الطباعة فقط — لا يتغيّر ما تحدّده الشاشة',
};
//# sourceMappingURL=i18n-paper.js.map